import {useMemo} from 'react'
import invariant from 'tiny-invariant'

import {MemexActionType, type MemexWorkflow} from '../../api/workflows/contracts'
import {isArchiveWorkflow} from '../../helpers/workflow-utilities'
import {useWorkflowSetFieldAction} from '../../hooks/use-workflow-action'
import {useWorkflowPermissions} from '../../hooks/use-workflow-permissions'

export const useWorkflowToggleState = (workflow: MemexWorkflow, localQuery: string) => {
  const defaultAction = workflow.actions[0]
  invariant(defaultAction, 'defaultAction must exist')
  const {selectedOption} = useWorkflowSetFieldAction(defaultAction)
  const {hasWorkflowWritePermission} = useWorkflowPermissions()

  const isToggleDisabled = useMemo(() => {
    const isSetField = defaultAction.actionType === MemexActionType.SetField
    const selectedOptionName = selectedOption?.nameHtml

    const isMissingSelectedOption = isSetField && !selectedOptionName

    const isQueryEmpty = localQuery.length === 0 && isArchiveWorkflow(workflow)

    return isMissingSelectedOption || !hasWorkflowWritePermission || isQueryEmpty
  }, [defaultAction.actionType, selectedOption?.nameHtml, localQuery.length, workflow, hasWorkflowWritePermission])

  return isToggleDisabled
}
